import { render } from "./CompleteCases.vue?vue&type=template&id=6f119674"
import script from "./CompleteCases.vue?vue&type=script&lang=js"
export * from "./CompleteCases.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/cases/CompleteCases.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6f119674"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6f119674', __exports__)) {
    console.log('reload')
    api.reload('6f119674', __exports__)
  }
  
  module.hot.accept("./CompleteCases.vue?vue&type=template&id=6f119674", () => {
    console.log('re-render')
    api.rerender('6f119674', render)
  })

}


export default __exports__